<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />
      <breadcrumb />
      <el-dropdown class="avatar-container" trigger="click">
        <div class="">
          <span style="margin-right:20px;"
            v-if="shop_expire_at">{{ $language('服务到期日期') }}：{{ shop_expire_at }}<span v-if="isDay(shop_expire_at)" class="red">({{ $language('到期') }})</span></span>
            <span style="margin-right:20px;"
            v-if="rate_end_date">{{ $language('料价汇率到期日期') }}：{{ rate_end_date }}<span v-if="isDay(rate_end_date)" class="red">({{ $language('到期') }})</span></span>
          <span style="margin-right:20px;"
            v-if="material && material.dollar_status">{{ $language('美元人民币') }}：{{ material.dollar }}</span>
          <span style="margin-right:20px;" v-if="material && material.rmb_status">{{ $language('离岸人民币') }}：{{ material.rmb }}</span>
          <svg-icon icon-class="user" style="margin-right:10px" />
          <span style="margin-right:10px">{{ user_nickname }}</span>
          <span style="margin-right:10px">{{ name }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- <router-link class="inlineBlock" to="/"> -->
          <el-dropdown-item>
            <div @click="show_dialog">
              {{ $language('修改密码') }}
            </div>
          </el-dropdown-item>
          <!-- </router-link> -->
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">{{ $language('退出登录') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="language" @command="$utils.changeLanguage">
        <span class="el-dropdown-link">
          {{ $language('中文') }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="CN">中文</el-dropdown-item>
          <el-dropdown-item command="EN">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <!-- <el-dialog title="修改密码" :visible.sync="show" width="30%"></el-dialog> -->
    <el-drawer :title="$language('修改密码')" :visible.sync="show">
      <div style="width:100%;padding:20px">
        <el-form label-width="80">
          <el-form-item :label="$language('新密码')" prop="password">
            <el-input v-model="form.password" placeholder="" size="mini" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$language('确认密码')" prop="confirmPassword">
            <el-input v-model="form.confirmPassword" placeholder="" size="mini" show-password></el-input>

          </el-form-item>
        </el-form>
        <el-button size="mini" @click="submit">{{ $language('保存') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import {
  putMyPassword
} from "@/api/system/user";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name", "user_nickname","shop_expire_at","rate_end_date", "material"])
  },
  data() {
    return {
      show: false,
      form: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  created() {
    this.$store.dispatch('getMaterial')
  },
  methods: {
    show_dialog() {
      this.show = true
    },
    submit() {
      putMyPassword(this.form).then(res => {
        this.show = false
        this.$message({
          message: this.$t("action.success"),
          type: "success"
        });
      })
    },
    // 年月日
    getDateDay(data){
      let date=new Date()
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d
    },
    // 判断和当前天数大小
    isDay(day){
let newDay=new Date(this.getDateDay(new Date()))
return newDay>new Date(day)
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.red{
  color: red;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .language {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 120px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
